<template lang="pug">
el-dialog(
  :title="title"
  :visible.sync="localVisible"
  :before-close="onClose"
  v-loading="loading"
  width="60%"
)
  el-row
    el-col
      h4(v-show="refundModal") ¿Está seguro de que quiere pagar?
      el-row(v-show="responseModal")
        el-col(:span="3") Rango de fechas:
        el-col(:span="3" :offset="0") Desde
        el-col(:span="3") Hasta
      el-row(v-show="responseModal")
        el-col(:span="3" :offset="3") <span v-text="dateRange[0]"></span>
        el-col(:span="3") <span v-text="dateRange[1]"></span>
      el-row(v-show="refundModal")
        el-col(:span="8" :offset="8") Desde
        el-col(:span="8") Hasta
      el-row(v-show="refundModal")
        el-col(:span="8") Rango de fechas:
        el-col(:span="8") <span v-text="dateRange[0]"></span>
        el-col(:span="8") <span v-text="dateRange[1]"></span>
      template(v-if="isSimpleRefundType")
        div(v-show="refundModal")
          el-row
            el-col(:span="8") Cantidad de {{ entity.toLowerCase() }}:
            el-col(:span="8") <span v-text="refundData.count"></span>
          el-row
            el-col(:span="8") Monto total:
            el-col(:span="8") <span v-text="refundData.total"></span>
      template(v-else)
        div(v-show="refundModal")
          el-divider
          el-row
            el-col(:span="8") Cantidad de {{ entity.toLowerCase() }} TBK:
            el-col(:span="8") <span v-text="refundData.transbank.count"></span>
          el-row
            el-col(:span="8") Monto total TBK:
            el-col(:span="8") <span v-text="refundData.transbank.total"></span>
          el-divider
          el-row
            el-col(:span="8") Cantidad de {{ entity.toLowerCase() }} Oneclick:
            el-col(:span="8") <span v-text="refundData.oneclick.count"></span>
          el-row
            el-col(:span="8") Monto total Oneclick:
            el-col(:span="8") <span v-text="refundData.oneclick.total"></span>
      el-row(:gutter="12" v-show="responseModal" style="margin: 25px 0")
        template(v-if="refundData.type === 'fintoc'")
          el-col(:span="6")
            el-card
              el-result(icon="info")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(:label="`Total ${entity}`") {{ refundData.response.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.response.total }}
          el-col(:span="6")
            el-card
              el-result(icon="success")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      label="Reembolsos Creados") {{ refundData.process.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.process.total }}
          el-col(:span="6")
            el-card
              el-result(icon="error")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Rechazad${gender}s`") {{ refundData.reject.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.reject.total }}
          el-col(:span="6")
            el-card
              el-result(icon="warning")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Omitid${gender}s`")
                      | {{ refundData.noIdentifier ? refundData.noIdentifier.count : 0 }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total")
                      | {{ refundData.noIdentifier ? refundData.noIdentifier.total : 0 }}
          el-col(
            :span="24"
            v-if="refundData.noIdentifier && refundData.noIdentifier.count > 0"
            style="margin-top: 12px")
            el-alert(type="warning" show-icon :closable="false" :title="noIdentifierAlertMessage")
        template(v-else-if="refundData.type === 'floid'")
          el-col(:span="6")
            el-card(shadow="never" style="font-size: 12px")
              el-result(icon="info" style="padding: 12px 8px")
                template(slot="extra")
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(:label="`Total ${entity}`") {{ refundData.response.count }}
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(label="Monto Total") {{ refundData.response.total }}
          el-col(:span="6")
            el-card(shadow="never" style="font-size: 12px")
              el-result(icon="success" style="padding: 12px 8px")
                template(slot="extra")
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(label="Reembolsos Creados") {{ refundData.process.count }}
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(label="Monto Total") {{ refundData.process.total }}
          el-col(:span="6")
            el-card(shadow="never" style="font-size: 12px")
              el-result(icon="error" style="padding: 12px 8px")
                template(slot="extra")
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(
                      :label="`${entity} Rechazad${gender}s`") {{ refundData.reject.count }}
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(label="Monto Total") {{ refundData.reject.total }}
          el-col(:span="6")
            el-card(shadow="never" style="font-size: 12px")
              el-result(icon="warning" style="padding: 12px 8px")
                template(slot="extra")
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(
                      :label="`${entity} Omitid${gender}s`") {{ refundData.skip.count }}
                  el-descriptions(:column="1" size="mini")
                    el-descriptions-item(label="Monto Total") {{ refundData.skip.total }}
          el-col(:span="24" v-if="refundData.skip.inProgressCount > 0" style="margin-top: 12px")
            el-alert(
              type="warning"
              show-icon
              :closable="false"
              :title="floidSkippedAlertMessage"
            )
          el-col(
            :span="24"
            v-if="refundData.noIdentifier && refundData.noIdentifier.count > 0"
            style="margin-top: 12px")
            el-alert(type="warning" show-icon :closable="false" :title="noIdentifierAlertMessage")
        template(v-else-if="refundData.type === 'mercado_pago'")
          el-col(:span="6")
            el-card
              el-result(icon="info")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(:label="`Total ${entity}`") {{ refundData.response.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.response.total }}
          el-col(:span="6")
            el-card
              el-result(icon="success")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Pagad${gender}s`") {{ refundData.refund.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.refund.total }}
          el-col(:span="6")
            el-card
              el-result(icon="error")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Rechazad${gender}s`") {{ refundData.reject.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.reject.total }}
          el-col(:span="6")
            el-card
              el-result(icon="warning")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Omitid${gender}s`")
                      | {{ refundData.noIdentifier ? refundData.noIdentifier.count : 0 }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total")
                      | {{ refundData.noIdentifier ? refundData.noIdentifier.total : 0 }}
          el-col(
            :span="24"
            v-if="refundData.noIdentifier && refundData.noIdentifier.count > 0"
            style="margin-top: 12px")
            el-alert(type="warning" show-icon :closable="false" :title="noIdentifierAlertMessage")
        template(v-else)
          el-col(:span="6")
            el-card
              el-result(icon="info")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`Total ${entity} TBK`"
                    ) {{ refundData.transbank.response.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total TBK"
                    ) {{ refundData.transbank.response.total }}
                  el-divider
                  el-descriptions
                    el-descriptions-item(
                      :label="`Total ${entity} Oneclick`"
                    ) {{ refundData.oneclick.response.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total Oneclick"
                    ) {{ refundData.oneclick.response.total }}
          el-col(:span="6")
            el-card
              el-result(icon="success")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} TBK Pagad${gender}s`"
                    ) {{ refundData.transbank.refund.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total TBK"
                  ) {{ refundData.transbank.refund.total }}
                  el-divider
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Oneclick Pagad${gender}s`"
                    ) {{ refundData.oneclick.refund.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total Oneclick"
                    ) {{ refundData.oneclick.refund.total }}
          el-col(:span="6")
            el-card
              el-result(icon="error")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} TBK Rechazad${gender}s`"
                    ) {{ refundData.transbank.reject.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total TBK"
                    ) {{ refundData.transbank.reject.total }}
                  el-divider
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Oneclick Rechazad${gender}s`"
                    ) {{ refundData.oneclick.reject.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total Oneclick"
                    ) {{ refundData.oneclick.reject.total }}
          el-col(:span="6")
            el-card
              el-result(icon="warning")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Omitid${gender}s`")
                      | {{ refundData.noIdentifier ? refundData.noIdentifier.count : 0 }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total")
                      | {{ refundData.noIdentifier ? refundData.noIdentifier.total : 0 }}
          el-col(
            :span="24"
            v-if="refundData.noIdentifier && refundData.noIdentifier.count > 0"
            style="margin-top: 12px")
            el-alert(type="warning" show-icon :closable="false" :title="noIdentifierAlertMessage")
  el-row.inline-form__actions
    el-button(type="primary" @click.prevent="onConfirm" v-show="refundModal") Aceptar
    el-button(type="danger" @click="onClose" v-show="refundModal") Cancelar
    el-button(type="primary" @click="onClose" v-show="responseModal") Aceptar
</template>

<script>
export default {
  name: 'RefundModal',
  props: {
    title: String,
    entity: String,
    gender: String,
    visible: Boolean,
    loading: Boolean,
    refundModal: Boolean,
    responseModal: Boolean,
    dateRange: Array,
    refundData: Object,
  },
  data() {
    return {
      localVisible: this.visible,
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
    },
  },
  computed: {
    isSimpleRefundType() {
      const type = this.refundData && this.refundData.type;
      return ['fintoc', 'mercado_pago', 'floid'].includes(type);
    },
    floidSkippedAlertMessage() {
      return 'Algunos reembolsos fueron omitidos porque Floid solo permite un reembolso '
        + 'por pago hasta el cierre del lote. Inténtalo nuevamente más tarde.';
    },
    noIdentifierAlertMessage() {
      return 'Algunos reembolsos fueron omitidos porque no cuentan con el identificador de la '
        + 'pasarela de pago necesario para procesar la devolución.';
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.inline-form__actions {
  margin-top: 20px;
}

::v-deep .el-descriptions-item__label,
::v-deep .el-descriptions-item__content {
  word-break: normal;
  overflow-wrap: break-word;
}
</style>
